export const UNKNOWN_VALUE = "Unknown";
export const VALUE_NOT_SET = "Not Set";

export const hasValue = <T extends { [key: string]: any }, K extends keyof T>(
  filterValues: T,
  field: K
) => {
  // Will only have a value if the key:value is defined and not empty
  return filterValues[field] && filterValues[field] !== "";
};
